import { Action, Menu, Role, ActionId, MenuId } from "@prisma/client";

export const ACTION_IDS = Object.keys(ActionId) as ActionId[];
export const MENU_IDS = Object.keys(MenuId) as MenuId[];

export type { Action, Menu, Role, ActionId, MenuId };
